module.exports = __webpack_public_path__ + "static/media/BudgetSmartSlide02.ad4dc234.jpg";